import dayjs from 'dayjs';
import {AiAgentSession} from 'src/types';

export interface SessionGroup {
    label: string;
    sessions: AiAgentSession[];
}

export const groupSessionsByDate = (
    sessions: AiAgentSession[],
    labels: {today: string; yesterday: string; prev7: string; prev30: string}
): SessionGroup[] => {
    const now = dayjs();
    const todayStart = now.startOf('day');
    const yesterdayStart = todayStart.subtract(1, 'day');
    const week = todayStart.subtract(7, 'day');
    const month = todayStart.subtract(30, 'day');

    const groups: Record<string, AiAgentSession[]> = {};
    const order: string[] = [];

    const addToGroup = (label: string, session: AiAgentSession) => {
        if (!groups[label]) {
            groups[label] = [];
            order.push(label);
        }
        groups[label].push(session);
    };

    const sorted = [...sessions].sort(
        (a, b) => dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf()
    );

    for (const session of sorted) {
        const created = dayjs(session.created_at);

        if (created.isAfter(todayStart)) {
            addToGroup(labels.today, session);
        } else if (created.isAfter(yesterdayStart)) {
            addToGroup(labels.yesterday, session);
        } else if (created.isAfter(week)) {
            addToGroup(labels.prev7, session);
        } else if (created.isAfter(month)) {
            addToGroup(labels.prev30, session);
        } else {
            const monthLabel = created.format('MMMM YYYY');
            addToGroup(monthLabel, session);
        }
    }

    return order.map((label) => ({label, sessions: groups[label]}));
};
